export default function cleanString(str: string) {
  if (!str) {
    return '';
  }
  return str
    .replace(/<(?:.|\n)*?>/gm, '')
    .replace(/\n/gm, ' ')
    .replace(/\"/gm, '\\"');
}
